export const azureSnapshotPaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/snapshots`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/snapshots`,
  detail: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/snapshots/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}`,
};
